import { useI18n } from '@change-corgi/core-react/i18n';
import { useTracking } from '@change-corgi/core-react/tracking';

import type { StarterDashboardV2PageData } from '#src/app/pages/starterDashboardV2/pageContext';
import { useStarterDashboardV2PageData } from '#src/app/pages/starterDashboardV2/pageContext';
import { buildDmEmailHref } from '#src/app/shared/utils/decisionMaker';

type DecisionMaker = StarterDashboardV2PageData['petition']['decisionMakersConnection']['nodes'][number];

type Result = ModelHookResult<
	{ decisionMakers: Array<DecisionMaker & { emailHref?: string | null }> },
	{
		handleEmailClick: () => void;
	}
>;

export function useEmailDecisionMakerModalBody(): Result {
	const track = useTracking();
	const { translate } = useI18n();

	const {
		data: {
			petition: {
				ask,
				slug,
				user: { displayName: starterDisplayName },
				signatureState: {
					signatureCount: { displayedLocalized: signatureCount },
				},
				decisionMakersConnection: { nodes: decisionMakers },
			},
		},
	} = useStarterDashboardV2PageData();

	const withEmailHref = decisionMakers
		.filter((dm): dm is DecisionMaker & { email: NonNullable<DecisionMaker['email']> } => Boolean(dm.email))
		.map((dm) => ({
			...dm,
			emailHref: buildDmEmailHref(
				{ email: dm.email, displayName: dm.displayName },
				{ ask, slug, signatureCount, starterDisplayName },
				translate,
			),
		}));

	const handleEmailClick = () => {
		void track('starter_dashboard_dm_list_email_click');
	};

	return {
		data: { decisionMakers: withEmailHref },
		actions: {
			handleEmailClick,
		},
	};
}
